import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

import { MAX_ITEMS_PER_PAGE, DEFAULT_PAGE } from '@kitch/data-access/constants';
import { AppPagesItem, Followers } from '@kitch/data-access/models';
import { FollowSearchParams } from '@kitch/data-access/models/search-params/follow';
import { FollowsService, TokenService } from '@kitch/data-access/services';

@Component({
  selector: 'app-favorites-channels',
  templateUrl: './favorites-channels.component.html',
  styleUrls: ['./favorites-channels.component.scss', './../favorites-shared.scss'],
})
export class FavoritesChannelsComponent implements OnInit {
  favoritesChannels: Followers[];
  isLoading: boolean;
  profileId: string;

  channelParams: FollowSearchParams;

  constructor(
    private followsService: FollowsService,
    private route: ActivatedRoute,
    private tokenService: TokenService,
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.profileId = this.tokenService.getProfileId();

    this.getFavoritesChannelsInfo().subscribe();
  }

  private getFavoritesChannelsInfo(): Observable<AppPagesItem<Followers>> {
    this.channelParams = {
      page: DEFAULT_PAGE,
      itemsPerPage: MAX_ITEMS_PER_PAGE,
      profileId: this.profileId,
    };

    return this.followsService.getFollowing(this.channelParams).pipe(
      tap((favoritesChannels) => {
        this.favoritesChannels = favoritesChannels.results;
      }),
      finalize(() => this.isLoading = false),
    );
  }
}
